import React, { useState } from "react";
import axios from "axios";
import Auth, { API_URL } from "../../../../utils/auth";
import { toast } from 'react-toastify';
import "./CircleModal.css";

const CircleModal = ({ isOpen, onClose, onSuccess, isAlreadyConnected }) => {
  const [botToken, setBotToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const user = Auth.getUser();
      const workspaceId = Auth.getWorkspaceId();

      if (!user || !workspaceId) {
        setError("User or workspace information not found");
        setIsLoading(false);
        return;
      }

      const payload = {
        workspaceId: parseInt(workspaceId),
        adminUserId: user.id,
        botToken: botToken,
      };

      const response = await axios.post(`${API_URL}/circle/circle-token`, payload, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth.getToken()}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success('Circle.so integration connected successfully!');
        onSuccess();
        onClose();
        setBotToken("");
      } else {
        setError(response.data?.message || "Failed to connect Circle integration");
      }
    } catch (error) {
      if (error.response) {
        setError(error.response.data?.message || "Failed to connect Circle integration");
      } else if (error.request) {
        setError("Network error. Please check your connection and try again.");
      } else {
        setError("Something went wrong. Please try again.");
      }
      toast.error("Failed to connect Circle.so integration. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setBotToken("");
    setError("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{isAlreadyConnected ? "Circle.so Integration Status" : "Connect Circle.so Integration"}</h2>
          <button className="modal-close" onClick={handleClose}>
            ×
          </button>
        </div>
        
        {isAlreadyConnected ? (
          // Already connected view
          <div>
            <div className="modal-body">
              <div className="success-message">
                <div className="success-icon">✓</div>
                <h3>Circle.so is already connected!</h3>
                <p>Your Circle.so integration is active and working properly.</p>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" onClick={handleClose} className="submit-button">
                Close
              </button>
            </div>
          </div>
        ) : (
          // Connection form view
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="botToken">Admin API Token:</label>
                <input
                  type="text"
                  id="botToken"
                  value={botToken}
                  onChange={(e) => setBotToken(e.target.value)}
                  required
                  placeholder="Enter your Circle.so Admin API token"
                />
              </div>

              {error && <div className="error-message">{error}</div>}
            </div>

            <div className="modal-footer">
              <button type="button" onClick={handleClose} className="cancel-button">
                Cancel
              </button>
              <button 
                type="submit" 
                className="submit-button" 
                disabled={isLoading || !botToken}
              >
                {isLoading ? "Connecting..." : "Connect"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default CircleModal;
